import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { RESET_PASSWORD_CHAUFFEUR, RESET_PASSWORD_CHAUFFEUR_SUCCESS, RESET_PASSWORD_CHAUFFEUR_ERROR } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* resetPasswordChauffeur({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/chauffeur/password-reset/initiate`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: RESET_PASSWORD_CHAUFFEUR_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: RESET_PASSWORD_CHAUFFEUR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: RESET_PASSWORD_CHAUFFEUR_ERROR, payload: error });
  }
}

export function* watchresetPasswordChauffeur() {
  yield takeEvery(RESET_PASSWORD_CHAUFFEUR, resetPasswordChauffeur);
}

function* resetPasswordChauffeurSaga() {
  yield all([fork(watchresetPasswordChauffeur)]);
}

export default resetPasswordChauffeurSaga;
